import api from '@/api/clients/api';
import { Gdpr, GdprClauseType, GdprLanguage } from '@/features/settings/api/types/gdpr';

class SettingsApi {
  async fetchGdprClauses(): Promise<Gdpr[]> {
    const { data } = await api.get<Gdpr[]>('/gdpr-clauses');

    return data;
  }

  async addGdprClause(
    gdprClause: string,
    language: GdprLanguage,
    type: GdprClauseType,
  ): Promise<Gdpr> {
    const { data } = await api.post<Gdpr>('/gdpr-clauses', {
      gdprClause,
      language,
      type,
    });

    return data;
  }
  async updateGdprClause(gdprClause: string, gdprClauseId: number): Promise<Gdpr> {
    const { data } = await api.put<Gdpr>(`/gdpr-clauses/${gdprClauseId}`, {
      gdprClause,
    });

    return data;
  }
  async deleteGdprClause(gdprClauseId: number): Promise<Gdpr> {
    const { data } = await api.delete<Gdpr>(`/gdpr-clauses/${gdprClauseId}`);

    return data;
  }
}

export const settingsApi = new SettingsApi();
